export default __webpack_public_path__ + "static/media/icon_box-widgets-wifi_calling.4b3f25ce.svg";